import { sum } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample from '@modules/admin/analytics/Analytics.SampleFilter'
import RefreshComponent from '@modules/core/icons/RefreshComponent'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import moment from 'moment'
import React, { Component } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Bar } from 'react-chartjs-2'
import { Trans } from 'react-i18next'

import Consultation from '@services/Consultations'
import { Loading } from '../../core/components/Loading'
import CustomPagination from '../../tableComponents/Pagination'
import ExportCsv from '../shared/ExportCsv'
import Title from '../shared/Title'

import './Analytics.NPS.scss'
import avatarImage from './profile1.jpg'

class AnalyticsNPS extends Component {
  state = {
    sample: {
      startDate: moment().startOf('day').toDate(),
      endDate: moment().toDate(),
      sampleRate: 'hour',
    },
    companiesFilter: [],

    npsEvolution: [],
    answerRate: [],
    npsAggregate: {
      total: 0,
      promoters: 0,
      passives: 0,
      detractors: 0,
    },

    segmentFilter: [],
    page: null,
    pageSize: 15,
    total: 0,
    isFetching: false,
    lastPage: 1,

    comments: [],
  }

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchComments)
  }

  fetchChartData = () => {
    const { sample, companiesFilter } = this.state

    const filters = {
      start_date: sample.startDate && moment(sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end_date: sample.endDate && moment(sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sample_rate: sample.sampleRate,
      company_api_keys: companiesFilter.length !== 0 ? companiesFilter.map((co) => co.api_key) : undefined,
    }

    this.setState({ isFetching: true })

    Consultation.analytics
      .getNpsRequestAnswer(filters)
      .then((response) => this.setState({ answerRate: response }))
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })

    Consultation.analytics
      .getEvolutionNps(filters)
      .then((response) =>
        this.setState({
          npsEvolution: response,
          npsAggregate: {
            total: sum(response.map((el) => Number(el.totals))),
            promoters: sum(response.map((el) => Number(el.promoters))),
            passives: sum(response.map((el) => Number(el.passives))),
            detractors: sum(response.map((el) => Number(el.detractors))),
          },
        })
      )
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  fetchComments = () => {
    const { page, pageSize, sample, companiesFilter, segmentFilter } = this.state

    const filters = {
      start_date: sample.startDate && moment(sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end_date: sample.endDate && moment(sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      company_api_keys: companiesFilter && companiesFilter.map((co) => co.api_key),
      segment: segmentFilter.length !== 0 ? segmentFilter : undefined,
    }

    this.setState({ isFetching: true })

    Consultation.analytics
      .getNpsComments({ page, pageSize, ...filters })
      .then((response) => {
        this.setState({
          comments: response.data,
          page: response.meta.current_page,
          total: response.meta.total,
          lastPage: response.meta.last_page,
          isFetching: false,
        })
      })
      .catch((e) => {
        window.alert(JSON.stringify(e.message, null, 2))
      })
  }

  fetchAllData = () => {
    this.fetchChartData()
    this.fetchComments()
  }

  toggleSegmentFilter = (selectedSegment) => {
    //selectedSegment must be string in ['promotor', 'passive', 'detractor']
    //example os state when adding segment: segmentFilters = ['promotor', 'passive']  => ['promotor', 'passive', 'detractor']
    if (this.state.segmentFilter.includes(selectedSegment)) {
      this.setState(
        { segmentFilter: this.state.segmentFilter.filter((el) => el !== selectedSegment) },
        this.fetchComments
      )
    } else {
      this.setState({ segmentFilter: [...this.state.segmentFilter, selectedSegment] }, this.fetchComments)
    }
  }

  componentDidMount() {
    this.fetchAllData()
  }

  render() {
    const {
      npsEvolution,
      answerRate,
      npsAggregate,
      comments,
      isFetching,
      page,
      lastPage,
      companiesFilter,
      segmentFilter,
    } = this.state

    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Calidad del servicio</Trans>} />
        <div className="npsFilterContainer">
          <AnalyticsSample
            input={{
              value: this.state.sample,
              onChange: (sample) => this.setState({ sample }),
            }}
          />
          <SelectCompanyField
            multi
            input={{
              value: companiesFilter,
              onChange: (companies) => this.setState({ companiesFilter: companies }),
            }}
          />
          <RefreshComponent actionOnClickRefresh={this.fetchAllData} />
        </div>
        <div className="chart-container">
          <Title title={<Trans>Net Promoter Score</Trans>}>
            <ExportCsv
              data={npsEvolution}
              filename={'Net_promotore_score.csv'}
              headers={[
                { label: 'Fecha', key: 'date' },
                { label: 'Promotores', key: 'promoters' },
                { label: 'Pasivos', key: 'passives' },
                { label: 'Detractores', key: 'detractors' },
                { label: 'Total', key: 'totals' },
              ]}
            />
          </Title>
          <Bar
            height={70}
            data={{
              labels: npsEvolution.map((el) => el.date),
              datasets: [
                {
                  label: 'Total',
                  backgroundColor: '#FFCA28',
                  data: npsEvolution.map((el) => el.totals && (el.promoters - el.detractors) / el.totals),
                },
              ],
            }}
            options={{
              scales: {
                yAxes: [
                  {
                    type: 'linear',
                    display: true,
                    id: 'y-linear',
                    ticks: {
                      min: -1,
                      max: 1,
                    },
                  },
                ],
              },
            }}
          />
        </div>
        <div className="chart-container">
          <Bar
            height={70}
            data={{
              labels: npsEvolution.map((el) => el.date),
              datasets: [
                {
                  label: 'Detractores',
                  backgroundColor: '#EC407A',
                  data: npsEvolution.map((el) => el.detractors),
                },
                {
                  label: 'Pasivos',
                  backgroundColor: '#C1CCD2',
                  data: npsEvolution.map((el) => el.passives),
                },
                {
                  label: 'Promotores',
                  backgroundColor: '#66BB6A',
                  data: npsEvolution.map((el) => el.promoters),
                },
              ],
            }}
            options={{
              scales: {
                xAxes: [
                  {
                    stacked: true,
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                  },
                ],
              },
            }}
          />
        </div>

        <div className="chart-container">
          <Title title={<Trans>NPS Solicitados VS Contestados</Trans>}>
            <ExportCsv
              data={answerRate}
              filename={'Nps_solicitados_vs_contestados.csv'}
              headers={[
                { label: 'Fecha', key: 'date' },
                { label: 'Contestados', key: 'answered' },
                { label: 'No Contestados', key: 'not_answered' },
                { label: 'Totales', key: 'totals' },
              ]}
            />
          </Title>
          <Bar
            height={70}
            data={{
              labels: answerRate.map((el) => el.date),
              datasets: [
                {
                  type: 'bar',
                  label: 'No contestados',
                  backgroundColor: '#EC407A',
                  data: answerRate.map((el) => el.not_answered),
                },
                {
                  type: 'bar',
                  label: 'Contestados',
                  backgroundColor: '#66BB6A',
                  data: answerRate.map((el) => el.answered),
                },
              ],
            }}
            options={{
              legend: {
                position: 'top',
              },
              scales: {
                yAxes: [
                  {
                    stacked: true,
                  },
                ],
              },
            }}
          />
        </div>

        <Loading isFetching={isFetching} />
        <div className="chart-container">
          <Title title={<Trans>NPS de Usuarios</Trans>} />
          <div className="commentsSectionHeader">
            <div className="commentFilters">
              <div className="segment" onClick={() => this.toggleSegmentFilter('promoter')}>
                <input type="checkbox" checked={segmentFilter.includes('promoter')} readOnly />
                <span className="segment">
                  <Trans>Promotores</Trans>
                </span>
                <ProgressBar now={(npsAggregate.promoters / npsAggregate.total) * 100} />
                <span className="sum"> {npsAggregate.promoters}</span>
              </div>
              <div className="segment" onClick={() => this.toggleSegmentFilter('passive')}>
                <input type="checkbox" checked={segmentFilter.includes('passive')} readOnly />
                <span className="segment">
                  <Trans>Pasivos</Trans>
                </span>
                <ProgressBar now={(npsAggregate.passives / npsAggregate.total) * 100} />
                <span className="sum">{npsAggregate.passives} </span>
              </div>
              <div className="segment" onClick={() => this.toggleSegmentFilter('detractor')}>
                <input type="checkbox" checked={segmentFilter.includes('detractor')} readOnly />
                <span className="segment">
                  <Trans>Detractores</Trans>
                </span>
                <ProgressBar now={(npsAggregate.detractors / npsAggregate.total) * 100} />
                <span className="sum"> {npsAggregate.detractors}</span>
              </div>
            </div>

            <div className="total">
              <div style={{ color: '#01a8e7', fontWeight: 600 }}>
                <Trans>NPS medio</Trans>
              </div>
              <div style={{ fontSize: 40, padding: '12px 0px' }}>
                {npsAggregate.total &&
                  ~~(((npsAggregate.promoters - npsAggregate.detractors) * 100) / npsAggregate.total) + '%'}
              </div>
            </div>
          </div>
        </div>

        <div className="list-cards">
          {comments.map((el) => (
            <div key={el.id} className="observationCard">
              <div className="avatar">
                <img src={avatarImage} style={{ height: 'inherit', width: 'inherit' }} alt={`avatarImage${el.id}`} />
              </div>
              <div className="name">{el.customer.name}</div>
              <div className="rating">
                <ProgressBar now={el.nps * 10} />
                <span style={{ paddingLeft: 12, color: '#01a8e7', fontWeight: 600 }}>{el.nps}</span>
              </div>
              <div className="date">{moment(el.received_at).format('LL')}</div>
              <div className="description">{el.observations}</div>
            </div>
          ))}
        </div>

        <CustomPagination onClickItem={this.handleChangePage} activePage={page} totalPages={lastPage} maxButtons={7} />
      </div>
    )
  }
}

export default AnalyticsNPS
